"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextStickersView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const inversify_1 = require("inversify");
const ui_core_api_gateway_1 = require("@desygner/ui-core-api-gateway");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const TextStickersView_style_1 = require("./TextStickersView.style");
function fetchTextStickers(apiGateway, from) {
    const path = `/api/search/stickers?from=${from}&limit=30&where%5Bactive%5D=1&where%5BisText%5D=1`;
    const response = apiGateway.fetch('GET', path, null);
    return response;
}
function loadTextStickers(apiGateway, from, callback, fallback) {
    const loadAmount = 30;
    fetchTextStickers(apiGateway, from)
        .then((response) => {
        const newStickers = response.data.map((item) => {
            return {
                title: '',
                source: item.url,
                data: {
                    id: Number(item.id),
                },
            };
        });
        callback({
            from: loadAmount,
            stickers: newStickers,
        });
    })
        .catch(() => {
        callback({
            from: loadAmount,
            stickers: fallback,
        });
    });
    return;
}
function TextStickersView({ apiConfiguration, fallback = [], onClick, }) {
    const [viewState, setViewState] = (0, react_1.useState)({
        from: 0,
        stickers: [],
    });
    const ref = (0, react_1.useRef)(null);
    const apiGateway = (0, react_1.useMemo)(() => {
        const container = new inversify_1.Container();
        container.load(ui_core_api_gateway_1.container);
        const apiGateway = container.get(ui_core_api_gateway_1.TYPES.ApiGateway);
        apiGateway.configure(apiConfiguration.baseUrl, apiConfiguration.userToken, apiConfiguration.company);
        return apiGateway;
    }, []);
    const loadTextStickersCallback = (0, react_1.useCallback)((changes) => {
        setViewState((prevState) => {
            const newState = {
                from: prevState.from + changes.from,
                stickers: [...prevState.stickers, ...changes.stickers],
            };
            return newState;
        });
    }, []);
    (0, react_1.useEffect)(() => {
        loadTextStickers(apiGateway, 0, loadTextStickersCallback, fallback);
    }, []);
    return ((0, jsx_runtime_1.jsx)(TextStickersView_style_1.StyledContainer, { ref: ref, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Grid, { assetType: 'icon', items: viewState.stickers, onClick: onClick, workspaceRef: ref }) }));
}
exports.TextStickersView = TextStickersView;
//# sourceMappingURL=TextStickersView.js.map